import React, { useEffect, useState } from "react";

import styled from "styled-components";

import Icon from "components/atoms/Icon";

const PROGRESS_MESSAGES = [
    "PDF 양식을 분석해 LaTeX 템플릿 파일을 생성하고 있습니다.",
    "분석에는 최대 몇 분이 소요될 수 있습니다.",
    "이 화면을 나가도 계속 진행됩니다. 나중에 다시 확인할 수 있어요.",
];

const Overlay = styled.div`
    position: fixed;
    inset: 0;
    z-index: 80;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(15, 23, 42, 0.35);
`;

const Panel = styled.div`
    width: min(440px, calc(100vw - 32px));
    padding: 18px;
    border: 1px solid #d4dee8;
    border-radius: 8px;
    background: #ffffff;
    box-shadow: 0 20px 36px rgba(15, 23, 42, 0.2);
`;

const Title = styled.div`
    color: #1f3348;
    font-size: 16px;
    font-weight: 800;
`;

const StatusRow = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    margin-top: 8px;
`;

const Message = styled.div`
    color: #42576b;
    font-size: 13px;
    line-height: 1.5;
`;

const ProgressTrack = styled.div`
    height: 8px;
    margin-top: 14px;
    overflow: hidden;
    border-radius: 999px;
    background: #e5edf5;
`;

const ProgressBar = styled.div`
    width: ${(props) => `${props.$progress}%`};
    height: 100%;
    border-radius: inherit;
    background: #138a6d;
    transition: width 180ms ease-out;
`;

export function isTemplateGenerationJob(job) {
    return job?.job_type === "template_generation";
}

export function isTemplateGenerationInProgress(job) {
    return isTemplateGenerationJob(job) && ["queued", "running"].includes(job.status);
}

export function isTemplateGenerationFailed(job) {
    return isTemplateGenerationJob(job) && job.status === "failed";
}

export default function ManuscriptTemplateOverlay({ job }) {
    const inProgress = isTemplateGenerationInProgress(job);
    const failed = isTemplateGenerationFailed(job);
    const [messageIndex, setMessageIndex] = useState(0);

    useEffect(() => {
        if (!inProgress) {
            setMessageIndex(0);
            return undefined;
        }

        const intervalId = window.setInterval(() => {
            setMessageIndex((prev) => (prev + 1) % PROGRESS_MESSAGES.length);
        }, 4000);

        return () => {
            window.clearInterval(intervalId);
        };
    }, [inProgress]);

    if (!inProgress && !failed) {
        return null;
    }

    return (
        <Overlay>
            <Panel
                role="dialog"
                aria-label="LaTeX 템플릿 생성 상태"
                onClick={(event) => {
                    event.stopPropagation();
                }}
            >
                <Title>{failed ? "LaTeX 템플릿 생성 실패" : "LaTeX 템플릿 생성 중"}</Title>
                <StatusRow>
                    {inProgress ? <Icon name="load" size="16px" color="#138a6d" /> : null}
                    <Message>
                        {failed
                            ? job?.message || "템플릿 생성 중 오류가 발생했습니다."
                            : PROGRESS_MESSAGES[messageIndex]}
                    </Message>
                </StatusRow>
                {!failed ? (
                    <ProgressTrack>
                        <ProgressBar $progress={job?.progress || 0} />
                    </ProgressTrack>
                ) : null}
            </Panel>
        </Overlay>
    );
}
